import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AmgUiModule } from 'src/app/shared/shared-base/amg-ui/amg-ui.module';
import { CovalentSharedModule } from 'src/app/shared/shared-base/covalent-shared/covalent-shared.module';
import { FlLoadingModule } from 'src/lib/fl-loading/fl-loading.module';
import { ModuleWithProvidersStrict } from 'src/util/angular/ng-core';
import { LoadingContainerComponent } from './loading-container/loading-container.component';
import { MomentDatePipe } from './momentDate.pipe';

const importsAndExports = [
  RouterModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  BrowserAnimationsModule,
  CovalentSharedModule,
  FlLoadingModule,
  AmgUiModule,
];

const declarationsAndExports = [MomentDatePipe, LoadingContainerComponent];

@NgModule({
  imports: importsAndExports,
  declarations: declarationsAndExports,
  exports: [...importsAndExports, ...declarationsAndExports],
})
export class SharedBaseModule {
  public static forRoot(): ModuleWithProvidersStrict {
    return {
      ngModule: SharedBaseModule,
      providers: [...AmgUiModule.forRoot().providers],
    };
  }
}
